<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label" />
            <div class="dx-field-value divide-y absolute h-16">
                <div />
                <div class="my-5" />
            </div>
        </div>
    </div>
</template>
<script setup></script>
